import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addToCart } from '../redux/cart/actionCreator';
import { decrementStock } from '../redux/products/actionCreator';


const ProductCard = ({product}) => {
    const dispatch = useDispatch();
    const {name, category, price, id, thumbnail, stock} = product;

  const  handleAddToCart = () => {

    const productInfo = {
      name,
      category,
      thumbnail,
      price,
      id
    }
    dispatch(addToCart(productInfo));
    dispatch(decrementStock(product))
  }
  
    return (
        <div className="lws-productCard">
          <img className="lws-productImage" src={thumbnail} alt="product" />
          <div className="p-4 space-y-2">
            <h4 className="lws-productName"> {name}</h4>
            <p className="lws-productCategory"> {category}</p>
            <div className="flex items-center justify-between pb-2">
              <p className="productPrice">BDT <span className="lws-price"> {price}</span></p>
              <p className="productQuantity">QTY <span className="lws-quantity"> {stock}</span></p>
            </div>
            <button className="lws-btnAddToCart" onClick={handleAddToCart} disabled={stock <= 0}>Add To Cart</button>
          </div>
        </div>
    );
};

export default ProductCard;